import { api } from 'utils';

import {
  FetchCargoClaimApiResponse,
  FetchCargoClaimHistoryApiResponse,
  FetchCargoClaimsApiResponse,
} from './api.types';

/*
 * Cargo claims does not sit under REACT_APP_BASE_URL.
 *
 * The gateway routes it by a `/cargo` prefix and strips it, so the service is
 * at `<gateway>/cargo/api` while everything else this app calls is at
 * `<gateway>/api`. Passing an absolute url makes axios ignore the instance's
 * baseURL for this call only — which keeps the shared client, and with it the
 * auth headers and the single refresh queue. A second axios instance would
 * have its own.
 */
const CARGO = process.env.REACT_APP_CARGO_BASE_URL ?? '';

export function fetchCargoClaimsApi({ queryKey }: any) {
  const [, , filter] = queryKey;

  return api().get<FetchCargoClaimsApiResponse>(`${CARGO}/claims`, {
    params: {
      page: filter.page,
      rows: filter.rows,
      /*
       * Sent only when set. The service treats an absent filter as no
       * restriction and an empty string as a restriction to the empty string,
       * so a blank search box would otherwise return nothing.
       */
      shipmentNo: filter.shipmentNumber || undefined,
      hawbNo: filter.hawbNumber || undefined,
      brand: filter.brand || undefined,
      company: filter.company || undefined,
      // 'All' is the service's own sentinel for "every status".
      status: filter.status || 'All',
    },
  });
}

export function fetchCargoClaimApi({ queryKey }: any) {
  const [, , reference] = queryKey;

  return api().get<FetchCargoClaimApiResponse>(`${CARGO}/claims/detail`, {
    params: { reference },
  });
}

export function fetchCargoClaimHistoryApi({ queryKey }: any) {
  const [, , , reference] = queryKey;

  return api().get<FetchCargoClaimHistoryApiResponse>(
    `${CARGO}/claims/history`,
    { params: { reference } }
  );
}
